import { useAuth0 } from '@auth0/auth0-react';
import { getUserRoles } from 'src/utils/authRoles';

export const METROBI_TIMING =
  "An exclusion applies to tonight only if optimization has not started. After optimization starts or completes, it applies beginning with the next night's plan. If a delivery is already marked for tonight, also unmark it in the DMP Metrobi tab; blacklisting alone does not pull the current delivery.";
export const METROBI_INHERITANCE =
  'Turning On clears only the location exclusion. Company-excluded locations stay Off, including when both exclusions were set. Other nightly eligibility rules still apply.';

export const useMetrobiAdmin = (): boolean => {
  const { user } = useAuth0();
  const roles = getUserRoles(user as Record<string, unknown> | undefined);
  return roles.includes('admin') || roles.includes('bp-admin');
};
